import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ReactComponent as FavouriteIcon } from '../../../assets/icons/favorite.svg'
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg'

import logo from '../../../assets/images/presentation/logo.svg'
import bottomSlogan from '../../../assets/images/presentation/slogan.svg'
import bannerLogo from '../../../assets/images/presentation/banner-log.svg'
import lastSection from '../../../assets/images/presentation/last-section-bg.png'
import productionlab from '../../../assets/images/presentation/design-lab.svg'

import {
    callPresentationTracker,
    getCollectionPresentationInfo,
    getFavouritePresentationInfo,
    getOldPresentationInfo,
    getPresentationInfo
} from '../../services/CommonService'
import { useDispatch } from 'react-redux'
import { closeLoader, openLoader, useLoader } from '../../redux_toolkit/Loader'
import LoginModal from '../common/LoginModal'
import {
    doFavourite,
    undoFavourite
} from '../../services/v3/Favourite/FavouriteService'
import { ReactComponent as FavouritedIcon } from '../../../assets/icons/favorited.svg'
import ForgetPassword from '../../modules/login-journey/ForgetPassword'
import AddToFavourite from '../common/AddToFavourite'
import { DoFavouriteActions } from '../../redux_toolkit/V3/DoFavourite'
import { SET_SELECTED_FAVOURITE } from '../../redux_toolkit/@types/action.types'
import { getUserPreference, STATIC_SET_CONSTANTS } from '../../helpers/Util'
import Image from '../../common/Image'

const PRESENTATION_PATH = {
    COLLECTION: 'collection',
    COLLECTIONS_PRESENTATION: 'collections-presentation',
    PRESENTATION: 'presentation',
    OLD_PRESENTATION: 'old_presentation'
}

const CollectionPresentation = ({
    onClose,
    isRequestFromRange = false,
    productIds = [],
    pageSource,
    hideFavBtn = false
}) => {
    const [isShowForgotPassword, setIsShowForgotPassword] = useState(false)
    const [presentationInfo, setPresentationInfo] = useState({})
    const [showFavourite, setShowFavourite] = useState(false)
    const [collectionInfo, setCollectionInfo] = useState([])
    const [isShowLogin, setIsShowLogin] = useState(false)
    const [trackId, setTrackId] = useState(null)
    const dispatch = useDispatch()
    const { id } = useParams()
    const loader = useLoader()
    const [currentPath, setCurrentPath] = useState('')
    const [presentationId, setPresentationId] = useState(null)

    useEffect(() => {
        const url = new URL(window.location.href)
        const queryParams = url.searchParams
        const presentationId = queryParams.get('presentationId')
        const segments = url.pathname.split('/')

        if (segments?.includes(PRESENTATION_PATH.COLLECTIONS_PRESENTATION)) {
            setCurrentPath(PRESENTATION_PATH.COLLECTIONS_PRESENTATION)
        } else if (presentationId) {
            setCurrentPath(PRESENTATION_PATH.PRESENTATION)
            setPresentationId(presentationId)
        } else if (
            segments?.includes(PRESENTATION_PATH.PRESENTATION) &&
            !presentationId
        ) {
            setCurrentPath(PRESENTATION_PATH.OLD_PRESENTATION)
        } else {
            setCurrentPath(PRESENTATION_PATH.COLLECTION)
        }
    }, [id])

    const getCollectionInfo = async () => {
        try {
            dispatch(openLoader())
            let data
            if (currentPath === PRESENTATION_PATH.COLLECTIONS_PRESENTATION) {
                data = await getPresentationInfo(id)
            } else if (currentPath === PRESENTATION_PATH.PRESENTATION) {
                data = await getPresentationInfo(presentationId)
            } else if (currentPath === PRESENTATION_PATH.OLD_PRESENTATION) {
                data = await getOldPresentationInfo(id)
            } else {
                data = await getCollectionPresentationInfo(
                    `${id}/presentation-info/public?fromPhotography=false`
                )
            }
            setPresentationInfo({
                collectionId: id,
                presentationName: data?.presentationName,
                market: data.market,
                season: data.season,
                brand: data.brand,
                middleDocument: data.middleDocument,
                endDocument: data.endDocument,
                coverDocument: data.coverDocument
            })
            setCollectionInfo(data?.productInfoForPresentationList)
            setIsShowLogin(false)
            dispatch(closeLoader())
        } catch (e) {
            dispatch(closeLoader())
        }
    }

    const getFavouriteInfo = async () => {
        try {
            dispatch(openLoader())
            let params = id && id !== 'my-favourite' ? `?folderId=${id}` : ''
            const data = await getFavouritePresentationInfo(params)
            setPresentationInfo({
                presentationName: data?.presentationName,
                brand: data?.brand,
                middleDocument: data?.middleDocument,
                endDocument: data?.endDocument,
                coverDocument: data?.coverDocument
            })
            setCollectionInfo(data?.productInfoForPresentationList)
            setIsShowLogin(false)
            dispatch(closeLoader())
        } catch (e) {
            dispatch(closeLoader())
        }
    }

    const getProductInfos = async () => {
        try {
            dispatch(openLoader())
            const data = await getCollectionPresentationInfo(
                `presentation-info/buyer?productIds=${productIds.join(',')}`
            )
            setCollectionInfo(data?.productInfoForPresentationList)
            setIsShowLogin(false)
            dispatch(closeLoader())
        } catch (e) {
            dispatch(closeLoader())
        }
    }

    const collectionPresentationTrackId = async () => {
        try {
            const data = await callPresentationTracker()
            setTrackId(data)
        } catch (e) {
            // eslint-disable-next-line no-empty,no-console
            console.log(e)
        }
    }

    useEffect(() => {
        if (isRequestFromRange) {
            setPresentationInfo({ presentationName: 'Range' })
            if (productIds.length > 0) getProductInfos()
        } else {
            if (pageSource === 'FAVOURITE') {
                getFavouriteInfo()
            } else {
                collectionPresentationTrackId()
                if (currentPath) {
                    getCollectionInfo()
                }
            }
        }
    }, [currentPath])

    const isTokenExist = () => {
        const token = localStorage.getItem('token')
        return !!token
    }

    const toggleIsFavourite = async (product) => {
        try {
            const id = product.id
            const bool = !product.isLiked
            dispatch(openLoader())
            if (bool) {
                let folderId = getUserPreference()?.defaultFavouriteFolder?.id
                let params = `?productIds=${id}`
                if (folderId) {
                    params += `&folderId=${folderId}`
                }
                await doFavourite(params)
            } else {
                await undoFavourite(id)
            }
            const cloneCollection = collectionInfo?.map((item) => {
                if (item.id === id) {
                    item.isLiked = bool
                }
                return item
            })
            setCollectionInfo(cloneCollection)
            if (bool) {
                dispatch(
                    DoFavouriteActions[SET_SELECTED_FAVOURITE]({
                        id: product.id,
                        referenceNumber: product.referenceNumber,
                        categoryResponse: { name: product.category },
                        mainFabricType: product.mainFabric,
                        designDocuments: [{ docUrl: product.frontImageUrl }]
                    })
                )
                setShowFavourite(bool)
            }
            dispatch(closeLoader())
        } catch (e) {
            dispatch(closeLoader())
        }
    }

    const toggleFavourite = async (product) => {
        if (!isTokenExist()) {
            setIsShowLogin(true)
        } else {
            await toggleIsFavourite(product)
        }
    }

    return (
        <>
            <div>
                <div className='design-view-modal presentation-play-modal'>
                    <div className='modal-content'>
                        {collectionInfo?.length === 0 && !loader ? (
                            <div className='no-presentaion-available'>
                                <div
                                    className='alert alert-secondary text-center'
                                    role='alert'
                                >
                                    No presentation available
                                </div>
                            </div>
                        ) : (
                            <div className='modal-body'>
                                {/* <div className='presentation-title sticky top-0 text-center p-4'>
                                    <p className='text-sm sm:text-base xl:text-xl black'>
                                        {presentationInfo?.presentationName}
                                    </p>
                                    {onClose && (
                                        <span
                                            className='absolute right-6 top-3 cursor-pointer'
                                            onClick={onClose}
                                        >
                                            <CloseIcon />
                                        </span>
                                    )}
                                </div> */}
                                <div className='modal-artboards scroll-y-label'>
                                    {!isRequestFromRange && (
                                        <section
                                            className={`into-section-v2 ${presentationInfo?.brand
                                                ?.length < 8
                                                ? 'large'
                                                : ''
                                                } ${!presentationInfo?.brand
                                                    ? 'no-brand'
                                                    : ''
                                                }`}
                                        >
                                            {/* <h1 className='brand-name-lebel'>
                                                {presentationInfo?.brand}
                                            </h1>
                                            <div className='intro-cover'>
                                                {presentationInfo?.coverDocument
                                                    ?.docUrl ? (
                                                    <Image
                                                        src={
                                                            presentationInfo
                                                                ?.coverDocument
                                                                ?.docUrl
                                                        }
                                                        alt='cover'
                                                        className='cover-photo'
                                                        isStatic={false}
                                                    />
                                                ) : (
                                                    <div className='cover-photo-container' />
                                                )}

                                                <div className='presentation-edit-category flex justify-between'>
                                                    <div className='cat-info'>
                                                        {presentationInfo?.market &&
                                                            presentationInfo?.season && (
                                                                <p>
                                                                    {
                                                                        presentationInfo?.market
                                                                    }
                                                                    :{' '}
                                                                    <span>
                                                                        {' '}
                                                                        {
                                                                            presentationInfo?.season
                                                                        }
                                                                    </span>
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                            <Image
                                                src='/images/nitex-presentation-logo.svg'
                                                alt='logo'
                                                className='bottom-logo'
                                            /> */}
                                            <div
                                                className='presentation-banner d-flex flex-column justify-content-between'
                                                style={{
                                                    backgroundImage: `url(${presentationInfo?.coverDocument?.docUrl})`
                                                }}
                                            >
                                                <div className='presentation-line-and-content'>
                                                    <div className='border-top-line d-flex justify-content-between align-items-center'>
                                                        <p className='title left-title uppercase'>

                                                            {(presentationInfo?.season || presentationInfo?.market) && (
                                                                <span className='text-black'>{
                                                                    presentationInfo?.season
                                                                }{' '}
                                                                    {
                                                                        presentationInfo?.market
                                                                    }
                                                                </span>
                                                            )}
                                                        </p>
                                                        <div>
                                                            <p className='title sub-right-title text-start uppercase'>
                                                                {presentationInfo?.presentationName && (
                                                                    <span className='text-black'>  {
                                                                        presentationInfo?.presentationName
                                                                    }{' '}
                                                                    </span>
                                                                )}
                                                            </p>
                                                            <p className='title right-title'></p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='middle-content text-center'>
                                                    <Image
                                                        src={logo}
                                                        alt='Brand Logo'
                                                        isStatic={false}
                                                        className='logo-image'
                                                    />
                                                    <span className='x-symbol d-block py-3'>
                                                        x
                                                    </span>
                                                    <p className='brand-name weight-700'>
                                                        {presentationInfo?.brand?.toUpperCase()}
                                                    </p>
                                                </div>

                                                <div className='presentation-line-and-content bottom-line-and-content'>
                                                    <div className='border-top-line d-flex justify-content-between align-items-center w-98'>
                                                        <p className='title left-title'>
                                                            <Link
                                                                to='https://www.nitex.com'
                                                                target='_blank'
                                                            >
                                                                www.nitex.com
                                                            </Link>
                                                        </p>
                                                        <p className='title right-title'>
                                                            <Image
                                                                src={bannerLogo}
                                                                alt='Nitex Logo'
                                                                isStatic={false}
                                                            />
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    )}
                                    {presentationInfo?.middleDocument
                                        ?.docUrl && (
                                            <div className='single-design-view-page'>
                                                <div className='presentation-view-container'>
                                                    <div className='full-page-photo'>
                                                        <Image
                                                            src={
                                                                presentationInfo
                                                                    ?.middleDocument
                                                                    ?.docUrl
                                                            }
                                                            alt='cover'
                                                            isStatic={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    {collectionInfo?.map((item) => (
                                        <div
                                            className='single-design-view-page relative'
                                            key={item.id}
                                        >
                                            <div className='presentation-line-and-content'>
                                                <div className='border-top-line black-line d-flex justify-content-between align-items-center'>
                                                    <div className='d-flex align-items-center'>
                                                        <p className='title left-title text-black uppercase'>
                                                            {
                                                                presentationInfo?.season
                                                            }
                                                        </p>
                                                        <p className='title left-sub-title text-black uppercase'>
                                                            {' '}
                                                            {
                                                                item?.marketName
                                                            }{' '}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p className='title sub-right-title text-start text-black uppercase'>
                                                            {' '}
                                                            {item?.category}
                                                        </p>
                                                        <p className='title right-title uppercase'>
                                                            {' '}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='presentation-view-container'>
                                                <div className='images-view-section'>
                                                    <div className='one-third full-photo'>
                                                        <Image
                                                            src={
                                                                item.frontImageUrl
                                                            }
                                                            alt='front'
                                                            isStatic={false}
                                                        />
                                                    </div>
                                                    <div className='one-third full-photo'>
                                                        <Image
                                                            src={
                                                                item.backImageUrl
                                                            }
                                                            alt='back'
                                                            isStatic={false}
                                                        />
                                                    </div>
                                                    <div className='one-third fabric-photo'>
                                                        <div className='single-fabric'>
                                                            <Image
                                                                src={
                                                                    item.fabricImageUrl
                                                                }
                                                                alt='fabric'
                                                                isStatic={false}
                                                            />
                                                        </div>
                                                        <div className='single-fabric'>
                                                            <Image
                                                                src={
                                                                    item.keyDetailsImageUrl
                                                                }
                                                                alt='keyDetails'
                                                                isStatic={false}
                                                            />
                                                        </div>
                                                        <div className='single-design-details'>
                                                            <div className='design-details-body'>
                                                                <div className='item-details'>
                                                                    <p className='regular-14'>
                                                                        <span>
                                                                            Style:
                                                                        </span>
                                                                        <span className='bold'>
                                                                            {
                                                                                item.referenceNumber
                                                                            }
                                                                        </span>
                                                                    </p>
                                                                    {item?.fabric2 ? (
                                                                        <>
                                                                            <div className='flex'>
                                                                                <p className='regular-14'>
                                                                                    <span>
                                                                                        Fabric
                                                                                        1
                                                                                        :
                                                                                    </span>
                                                                                    <span>
                                                                                        {
                                                                                            item.fabric1
                                                                                        }

                                                                                        ,{' '}
                                                                                        <span>
                                                                                            {
                                                                                                item.weight1
                                                                                            }
                                                                                        </span>
                                                                                    </span>
                                                                                </p>
                                                                            </div>
                                                                            <div className='flex'>
                                                                                <p className='regular-14'>
                                                                                    <span>
                                                                                        Fabric
                                                                                        2:
                                                                                    </span>
                                                                                    <span>
                                                                                        {
                                                                                            item.fabric2
                                                                                        }

                                                                                        ,
                                                                                    </span>
                                                                                    <span>
                                                                                        {
                                                                                            item.weight2
                                                                                        }
                                                                                    </span>
                                                                                </p>
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <p className='regular-14'>
                                                                                <span>
                                                                                    Fabric:
                                                                                </span>
                                                                                <span>
                                                                                    {
                                                                                        item.fabric1
                                                                                    }
                                                                                    {
                                                                                        item.weight1
                                                                                    }
                                                                                </span>
                                                                            </p>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='presentation-line-and-content bottom-line-and-content'>
                                                <div className='border-top-line black-line d-flex justify-content-between align-items-center'>
                                                    <p className='title left-title text-black'>
                                                        <Link to='https://www.nitex.com' target='_blank'>www.nitex.com</Link>
                                                    </p>
                                                </div>
                                            </div>
                                            <div className='productionlab right'>
                                                <Image
                                                    src={productionlab}
                                                    isStatic={false}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                    {presentationInfo?.endDocument?.docUrl && (
                                        <div className='single-design-view-page'>
                                            <div className='presentation-view-container'>
                                                <div className='full-page-photo'>
                                                    <Image
                                                        src={
                                                            presentationInfo
                                                                ?.endDocument
                                                                ?.docUrl
                                                        }
                                                        alt='cover'
                                                        isStatic={false}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {!isRequestFromRange && (
                                        <section className='last-section-v2'>
                                            <div
                                                className='presentation-banner d-flex flex-column justify-content-between'
                                                style={{
                                                    backgroundImage: `url(${lastSection})`,
                                                    backgroundPosition:
                                                        '50% 30%'
                                                }}
                                            >
                                                <div className='presentation-line-and-content'>
                                                    <div className='border-top-line d-flex justify-content-between align-items-center'>
                                                        <p className='title left-title uppercase'>
                                                            {presentationInfo?.season || presentationInfo?.market && (
                                                                <span className='text-black'>
                                                                    {
                                                                        presentationInfo?.season
                                                                    }
                                                                    {
                                                                        presentationInfo?.market
                                                                    }
                                                                </span>
                                                            )}
                                                        </p>
                                                        <div>
                                                            <p className='title sub-right-title text-start uppercase'>
                                                                {presentationInfo?.presentationName && (
                                                                    <span className='text-black'>
                                                                        {
                                                                            presentationInfo?.presentationName
                                                                        }
                                                                    </span>
                                                                )}
                                                            </p>
                                                            <p className='title right-title uppercase'></p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='middle-content text-center'>
                                                    <Image
                                                        src={bottomSlogan}
                                                        isStatic={false}
                                                        className='bottom-slogan'
                                                    />
                                                </div>
                                                <div className='presentation-line-and-content bottom-line-and-content'>
                                                    <div className='border-top-line d-flex justify-content-between align-items-center w-98'>
                                                        <p className='title left-title text-neon'>
                                                            <Link
                                                                to='https://www.nitex.com'
                                                                target='_blank'
                                                            >
                                                                www.nitex.com
                                                            </Link>
                                                        </p>
                                                        <p className='title right-title'>
                                                            <Image
                                                                src={bannerLogo}
                                                                isStatic={false}
                                                            />
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {showFavourite && (
                    <AddToFavourite
                        isVisible={showFavourite}
                        setIsVisible={setShowFavourite}
                    />
                )}
            </div>
            {isShowLogin && (
                <LoginModal
                    trackId={trackId}
                    callback={getCollectionInfo}
                    openForgotPassword={() => {
                        setIsShowForgotPassword(true)
                        setIsShowLogin(false)
                    }}
                />
            )}
            {isShowForgotPassword && !isShowLogin && (
                <ForgetPassword
                    onClose={() => setIsShowForgotPassword(false)}
                />
            )}
        </>
    )
}

export default CollectionPresentation
